import './polyfills'; // eslint-disable-line import/no-unassigned-import
import moment from 'moment';
import momentDurationFormat from 'moment-duration-format';


/**
 * This function initializes everything in the app.
 * It is called before any UI is rendered, useful for setting up
 * 3rd-party services.
 */
export default function initializeApp() {
  // Install the 'moment-duration-format' utility. See https://github.com/jsmreese/moment-duration-format
  momentDurationFormat(moment);

}
